import React, { useState, useEffect } from 'react';
import NotFoundPage from './NotFoundPage';

/**
 * Wrapper component that protects promo routes.
 * When promos are disabled in the admin panel, this renders the 404 page
 * instead of the promo content.
 */
const ProtectedPromoRoute = ({ children }) => {
  const [promoEnabled, setPromoEnabled] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  useEffect(() => {
    const checkPromoStatus = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/static-config/promo`);
        const result = await response.json();

        if (result.success) {
          setPromoEnabled(result.data.enabled);
        } else {
          // If API fails, default to disabled for security
          setPromoEnabled(false);
        }
      } catch (error) {
        console.error('Error checking promo status:', error);
        // If API fails, default to disabled for security
        setPromoEnabled(false);
      } finally {
        setLoading(false);
      }
    };

    checkPromoStatus();
  }, [API_BASE_URL]);

  // Show nothing while loading to prevent flash
  if (loading) {
    return null;
  }

  // If promos are disabled, show 404 page
  if (!promoEnabled) {
    return <NotFoundPage />;
  }

  // Promos are enabled, render the actual promo page
  return children;
};

export default ProtectedPromoRoute;
